import { InspirationPanel } from '../InspirationPanel';
import { RenderStyleGallery } from '../RenderStyleGallery';
import { ShowKitPanel } from '../ShowKitPanel';
import { CoverCard, SongCard, SoundtrackPicker } from './MtvPanel';
import { LyricsCard } from './LyricsCard';
import { StemsCard } from './StemsCard';
import { VoiceSwapCard } from './VoiceSwapCard';
import { LeadSingerCard } from './LeadSingerCard';
import { MtvMixCard } from './MtvMixCard';

/** MTV Creator wizard: Song → Sound → Cast & Places → Inspiration & Look → Storyboard → Produce → Mix & Final Cut. */
export function MtvStep({ step, project, catalog, voices, onChanged, onPatch, onGoToStep, idea, storyboard, shots, final }) {
  const p = { project, onChanged };
  switch (step) {
    case 1:
      return (
        <div className="space-y-5" data-testid="mtv-step-song">
          {idea}
          <div className="grid gap-4 lg:grid-cols-2"><SongCard key={project.id} {...p} /><LyricsCard key={`l-${project.id}`} {...p} /></div>
        </div>
      );
    case 2:
      return (
        <div className="space-y-4" data-testid="mtv-step-sound">
          <div className="grid gap-4 lg:grid-cols-2"><StemsCard {...p} /><VoiceSwapCard key={project.id} {...p} /></div>
          <CoverCard {...p} />
          <SoundtrackPicker {...p} />
        </div>
      );
    case 3:
      return (
        <div className="space-y-6" data-testid="mtv-step-cast">
          <LeadSingerCard {...p} />
          <ShowKitPanel project={project} catalog={catalog} voices={voices} onChanged={onChanged} />
        </div>
      );
    case 4:
      return (
        <div className="space-y-6" data-testid="mtv-step-look">
          <InspirationPanel {...p} />
          <RenderStyleGallery project={project} catalog={catalog} onPatch={onPatch} />
        </div>
      );
    case 5: return storyboard;
    case 6: return shots;
    default:
      return <div className="space-y-8" data-testid="mtv-step-mix"><MtvMixCard {...p} onGoToStep={onGoToStep} />{final}</div>;
  }
}
